export const ReportSubscriberState = {
    errorCode : 0,
    statusCode : 0,
    regionList : [],
    message : '',
    countryList : [],
    userList:[],
}